module.exports = __webpack_public_path__ + "img/bj-beaverjam-hero.7a157f32.jpg";